import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  SimpleGrid,
  useColorModeValue
} from "@chakra-ui/react";
import { PessoaType } from "models/person_type";
import FormClient from "views/admin/clients/components/Form";
import useClients from "views/admin/clients/hooks/useClients";
import useProductOrder from "views/admin/order/product/hooks/useProductOrder";
import ComprasForm from "./components/Form";
import ComprasTable from "./components/Table";
import useCompras from "./hooks/useCompras";
import { ConditionalRenderer } from "views/admin/components/ConditionalRenderer";
import { SimpleConditionalFrame } from "views/admin/components/SimpleConditionalFrame";

const ComprasScreen = () => {
  const {
    list,
    usuario,
    loading,
    show,
    error,
    errorMsg,
    errorTitle,
    accountSelected,
    showDelete,
    fornecedores,
    selectedFornecedor,
    selectedCategoria,
    cancelRef,
    itemList,
    edit,
    add,
    loadFornecedores,
    showError,
    closeError,
    showDeleteModal,
    closeDelete,
    categoria,
    changeFornecedor,
    changeCategoria,
    changeCondicaoPagamento,
    selectedCondicaoPagamentos,
    deletar,
    changeInput,
    save,
    condicaoPagamentos,
    showModal,
    changeUser,
    selectedUser,
    users,
    addRowItem,
    deleteRow,
    editRow,
    dataCompra,
    dataPrevista,
    addRowItemFinanceiro,
    deleteRowFinanceiro,
    editRowFinanceiro,
    itemListFinanceiro,
    centroCusto,
    changeCentroCusto,
    changeConta,
    changeDepto,
    depto,
    generateParcela,
    contaFinanceiroLista,
    selectedCentroCusto,
    selectedConta,
    selectedDepto,
    changeDeptoOrcamento,
    listDepto,
    selectedDeptoOrcamento,
    filiais,
    onChangeFilial,
    selectedFilial,
    addRowItemServico,
    deleteRowSerico,
    editRowServido,
    itemListServico,

  } = useCompras();

  const {
    enderecoList,
    showFormPessoa,
    adicionarContato,
    adicionarEndereco,
    bairroRef,
    cargoContatoRef,
    cepRef,
    changeFilial,
    changeItemPessoa,
    cidadeRef,
    classificacaoList,
    classificacaoRef,
    client,
    complementoRef,
    contatoList,
    contribuinteRef,
    deleteContato,
    showPessoa,
    idTipoRef,
    documentoRef,
    razaoSocialRef,
    nomeFantasiaRef,
    inscricaoMunicipalRef,
    inscricaoEstadualRef,
    tipoPessoaList,
    ruaRef,
    numeroRef,
    estadoRef,
    principalRef,
    loadCEP,
    viaCepEnd,
    deleteEnd,
    emailContatoRef,
    principalContatoRef,
    nomeContatoRef,
    filial,
    telefoneContatoRef,
    pessoaFilial,
    nomeClinteRef,
    editPessoa,
    saveCliente,
    errorCliente,
    errorMsgCliente,
    errorTitleCliente,
    cancelPessoaRef,
    closeErrorPessoa,
    contaList,
    bancoRef,
    agenciaRef,
    tipoRef,
    numeroContaRef,
    titularRef,
    tipoPessoaRef,
    documentoContaRef,
    descricaoRef,
    obsRef,
    deleteConta,
    adcionarConta
  } = useClients();

  const editarPessoa = (item: PessoaType) => {
    if (item === undefined || item === null) {
      showError("Erro!", "Selecione o Fornecedor para editar seus dados!");
    } else {
      editPessoa(item);
    }
  };

  const savePersonData = async () => {
    await saveCliente();
    await loadFornecedores();
  };
  const textColor = useColorModeValue("navy.700", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");
  const borderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");

  const { produtos } = useProductOrder();
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <ConditionalRenderer
        conditions={[
          {
            condition: show,
            component: (
              <SimpleConditionalFrame
                backClick={() => showModal(false)}
                title="Pedido de Compra"
              >
                <ComprasForm
                  show={show}
                  showModal={showModal}
                  accountSelected={accountSelected}
                  brandStars={brandStars}
                  categoria={categoria}
                  changeCategoria={changeCategoria}
                  changeCondicaoPagamento={changeCondicaoPagamento}
                  changeFornecedor={changeFornecedor}
                  changeInput={changeInput}
                  condicaoPagamento={condicaoPagamentos}
                  editPessoa={editarPessoa}
                  fornecedor={fornecedores}
                  loading={loading}
                  save={save}
                  selectedCategoria={selectedCategoria}
                  selectedCondicaoPagamentos={selectedCondicaoPagamentos}
                  selectedFornecedor={selectedFornecedor}
                  showFormPessoa={showFormPessoa}
                  textColor={textColor}
                  changeUser={changeUser}
                  selectedUser={selectedUser}
                  users={users}
                  borderColor={borderColor}
                  itemList={itemList}
                  addRowItem={addRowItem}
                  deleteRow={deleteRow}
                  editRow={editRow}
                  dataCompra={dataCompra}
                  dataPrevista={dataPrevista}
                  addRowItemFinanceiro={addRowItemFinanceiro}
                  deleteRowFinanceiro={deleteRowFinanceiro}
                  editRowItemFinanceiro={editRowFinanceiro}
                  itemListFinanceiro={itemListFinanceiro}
                  user={usuario}
                  centroCusto={centroCusto}
                  changeCentroCusto={changeCentroCusto}
                  changeConta={changeConta}
                  changeDepto={changeDepto}
                  contaFinanceiroLista={contaFinanceiroLista}
                  depto={depto}
                  generateParcela={generateParcela}
                  selectedCentroCusto={selectedCentroCusto}
                  selectedConta={selectedConta}
                  selectedDepto={selectedDepto}
                  changeDeptoOrcamento={changeDeptoOrcamento}
                  listDepto={listDepto}
                  selectedDeptoOrcamento={selectedDeptoOrcamento}
                  filiais={filiais}
                  onChangeFilial={onChangeFilial}
                  selectedFilial={selectedFilial}
                  addRowService={addRowItemServico}
                  deleteRowService={deleteRowSerico}
                  editRowService={editRowServido}
                  itemListServico={itemListServico}
                  produtos={produtos}
                  showError={showError}
                />

              </SimpleConditionalFrame>
            )
          }
        ]}
        fallback={(
          <SimpleGrid
            mb="20px"
            columns={{ sm: 1, md: 1 }}
            spacing={{ base: "20px", xl: "20px" }}
          >
            <ComprasTable
              add={add}
              cancelRef={cancelRef}
              closeDelete={closeDelete}
              deletar={showDeleteModal}
              edit={edit}
              list={list}
              remove={deletar}
              showDelete={showDelete}
            />
          </SimpleGrid>
        )}
      />

      <FormClient
        enderecoList={enderecoList}
        accountSelected={client}
        brandStars={brandStars}
        error={error}
        loading={loading}
        save={savePersonData}
        nomeRef={nomeClinteRef}
        show={showPessoa}
        showModal={showFormPessoa}
        textColor={textColor}
        idTipoRef={idTipoRef}
        classificacaoRef={classificacaoRef}
        documentoRef={documentoRef}
        razaoSocialRef={razaoSocialRef}
        nomeFantasiaRef={nomeFantasiaRef}
        inscricaoMunicipalRef={inscricaoMunicipalRef}
        inscricaoEstadualRef={inscricaoEstadualRef}
        contribuinteRef={contribuinteRef}
        classificacaoList={classificacaoList}
        tipoPessoaList={tipoPessoaList}
        bairroRef={bairroRef}
        cepRef={cepRef}
        ruaRef={ruaRef}
        numeroRef={numeroRef}
        complementoRef={complementoRef}
        cidadeRef={cidadeRef}
        estadoRef={estadoRef}
        principalRef={principalRef}
        loadCEP={loadCEP}
        viaCepEnd={viaCepEnd}
        adicionarEnd={adicionarEndereco}
        deleteEnd={deleteEnd}
        contatoList={contatoList}
        deleteContato={deleteContato}
        adicionarContato={adicionarContato}
        cargoContatoRef={cargoContatoRef}
        emailContatoRef={emailContatoRef}
        nomeContatoRef={nomeContatoRef}
        principalContatoRef={principalContatoRef}
        telefoneContatoRef={telefoneContatoRef}
        changeItem={changeItemPessoa}
        filial={filial}
        changeFilial={changeFilial}
        pessoaFilial={pessoaFilial}
        adcionarConta={adcionarConta}
        agenciaRef={agenciaRef}
        bancoRef={bancoRef}
        contaList={contaList}
        deleteConta={deleteConta}
        descricaoRef={descricaoRef}
        documentoContaRef={documentoContaRef}
        numeroContaRef={numeroContaRef}
        obsRef={obsRef}
        tipoPessoaRef={tipoPessoaRef}
        tipoRef={tipoRef}
        titularRef={titularRef}

      />

      <AlertDialog
        isOpen={error}
        leastDestructiveRef={cancelRef}
        onClose={closeError}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {errorTitle}
            </AlertDialogHeader>

            <AlertDialogBody>{errorMsg}</AlertDialogBody>

            <AlertDialogFooter>
              <Button
                ref={cancelRef}
                onClick={closeError}
                colorScheme={"blue"}
              >
                OK
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};
export default ComprasScreen;
